module.exports = __webpack_public_path__ + "img/014-kickstarter.ab71313b.svg";